export default {
  primary: "Poppins",
};
  